import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getAgencies(filter) {
  try {
    let res = await http.get('/Agency');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateAgency(id, data) {
  try {
    const res = await http.put(`/Agency/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewAgency(data) {
  try {
    const res = await http.post('Agency', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
